import { createGlobalStyle } from 'styled-components';
import { media } from '../base/media/media';
import fonts from './fonts';

const GlobalStyle = createGlobalStyle`
	* {
		border: 0;
		box-sizing: inherit;
		-webkit-font-smoothing: antialiased;
		font-weight: inherit;
		margin: 0;
		outline: 0;
		padding: 0;
		text-decoration: none;
		text-rendering: optimizeLegibility;
		-webkit-appearance: none;
		-moz-appearance: none;
	}

	html {
		font-size: 62.5%;
	}

	html, body {
		min-height: 100%;
	}

	strong {
		font-weight: 500;
		color: ${({ theme }) => theme.colors.black};
	}

	body {
		font-size: ${props => props.theme.fonts.fontSize};
		font-family: ${props => props.theme.fonts.fontFamily};
		line-height: ${props => props.theme.fonts.lineHeight};
		color: ${props => props.theme.colors.gray};
		margin: 0;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;

		${media.tablet` font-size: ${props => props.theme.fonts.fontSizeTablet}`}
		${media.desktopSmall`
			padding-top: 0;
			font-size: ${props => props.theme.fonts.fontSizeDesktop};
			line-height: 3.4rem;
		`}
	}

	svg {
		#briet-text { font-weight: 700 }
	}

	.Heading1 {
		display: block;
		color: ${props => props.theme.colors.black};
		font-size: 2.4rem;
		font-weight: 900;
		line-height: 2.8rem;
		margin-bottom: 2rem;

		${media.tablet`
			font-size: 2.6rem;
			line-height: 3rem;
		`};

		${media.desktopSmall`
			font-size: 3rem;
			line-height: 3.8rem;
		`}
	}

	.Heading2 {
		display: block;
		color: ${props => props.theme.colors.black};
		font-size: 2rem;
		font-weight: 900;
		line-height: 2.8rem;
		margin-bottom: 2rem;

		${media.tablet`
			font-size: 2.2rem;
			line-height: 3rem;
		`};

		${media.desktopSmall`
			font-size: 2.4rem;
			line-height: 3.4rem;
		`}
	}

	.Heading3 {
		display: block;
		color: ${props => props.theme.colors.black};
		font-size: 2rem;
		font-weight: 900;
		line-height: 2.8rem;
		margin-bottom: 2rem;

		${media.tablet`
			font-size: 2.2rem;
			line-height: 3rem;
		`};

		${media.desktopSmall`
			font-size: 2.4rem;
			line-height: 3.4rem;
		`}
	}

	${fonts}

	u {
		text-decoration: underline;
	}
`;

export default GlobalStyle;
